import { ApiException } from '../../api/services/api-service';
import { storageUtils } from '../../utils/storage-utils';
import { catchException, commonActions, handleApi } from "./common";
import { IShardRepositoryTestConnectionRequest, IShardRepository } from "../../api/entities/shard-repository";
import { shardRepositoryService } from "../../api/services/shard-repository-service";

export enum StorageActionType {
  PROVIDER_TYPE = "PROVIDER_TYPE",
  CHECK_UNIQUE_NAME = "CHECK_UNIQUE_NAME",
  STORAGE_LISTING = "STORAGE_LISTING",
  SET_TEST_CONNECTION_FLAG = "SET_TEST_CONNECTION_FLAG",
  SET_STORAGE_NODE_DETAIL = "SET_STORAGE_NODE_DETAIL",
  STORAGE_ISSUES_FETCH_SUCCESS = "STORAGE_ISSUES_FETCH_SUCCESS",
}

export const STORAGE_ENTITY_NAME = "storage";

class StorageActions {

  storageListing(data: IShardRepository[]) {
    return {
      type: StorageActionType.STORAGE_LISTING as typeof StorageActionType.STORAGE_LISTING,
      payload: data,
    };
  }

  uniqueName(data: boolean) {
    return {
      type: StorageActionType.CHECK_UNIQUE_NAME as typeof StorageActionType.CHECK_UNIQUE_NAME,
      data,
    };
  }

  setTestConnectionFlag(flag: boolean) {
    return {
      type: StorageActionType.SET_TEST_CONNECTION_FLAG as typeof StorageActionType.SET_TEST_CONNECTION_FLAG,
      flag: flag,
    };
  }

  setStorageNodeDetail(data: IShardRepository) {
    return {
      type: StorageActionType.SET_STORAGE_NODE_DETAIL as typeof StorageActionType.SET_STORAGE_NODE_DETAIL,
      data: data,
    };
  }

  //-------------API call for fetching all storages ------------------//
  getStorageList() {
    return (dispatch) => {
      handleApi(shardRepositoryService
        .getPage({})
        .then((page) => {
          if (page) {
            dispatch(this.storageListing(page.data));
          }
        }), true);
    };
  }

  //----------------api call to Test Connection-----------//
  testConnection(payload: IShardRepositoryTestConnectionRequest) {
    return (dispatch) => {
      dispatch(commonActions.startLoading());
      shardRepositoryService.testConnection(storageUtils.cleanNotApplicableFields(payload, true))
        .then((result) => {
          dispatch(commonActions.stopLoading());
          dispatch(this.setTestConnectionFlag(result.isConnectionSuccessful));
          if (!result.isConnectionSuccessful && result.msg) {
            dispatch(commonActions.showSnackBar(true, result.msg));
          }
        }).catch((exception: ApiException) => {
          dispatch(this.setTestConnectionFlag(false));
          throw exception;
        }).catch(catchException());
    };
  }

  getNodeDetail(id: string) {
    return (dispatch) => {
      handleApi(shardRepositoryService
        .get(id)
        .then((data) => {
          if (data) {
            dispatch(storageActions.setStorageNodeDetail(data));
          }
        }), true);
    };
  }
}

export const storageActions = new StorageActions();

export type StorageAction =
  | ReturnType<typeof storageActions.storageListing>
  | ReturnType<typeof storageActions.uniqueName>
  | ReturnType<typeof storageActions.setTestConnectionFlag>
  | ReturnType<typeof storageActions.setStorageNodeDetail>;
